import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { ThfFieldModule, ThfI18nPipe, ThfModalModule } from '@totvs/thf-ui';

import { ThfModalPasswordRecoveryComponent } from './thf-modal-password-recovery.component';
import { ThfModalPasswordRecoveryErrorMessageComponent
} from './thf-modal-password-recovery-error-message/thf-modal-password-recovery-error-message.component';
import { ThfModalPasswordRecoveryService } from './thf-modal-password-recovery.service';

/**
 * @description
 *
 * MÃ³dulo do template do thf-modal-password-recovery.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    ThfFieldModule,
    ThfModalModule
  ],
  declarations: [
    ThfModalPasswordRecoveryComponent,
    ThfModalPasswordRecoveryErrorMessageComponent
  ],
  exports: [
    ThfModalPasswordRecoveryComponent,
    ThfModalPasswordRecoveryErrorMessageComponent
  ],
  providers: [ThfI18nPipe, ThfModalPasswordRecoveryService]
})
export class ThfModalPasswordRecoveryModule { }
